<template lang="pug">
  .card
    .card-content
      .columns
        .column.is-6
          p.title
            | Resolución
          p.subtitle
            | Resuelve: 
            b {{ ticket.resuelve }}
          p.has-text-grey.is-size-6
            small.has-text-grey-darker Fecha Resolución: &nbsp
            | {{ ticket.fechaResolucion }}
          p.has-text-grey.is-size-6
            | Diagnóstico: 
            b {{ getDiagnostico(ticket.diagnostico) }}
          p.has-text-grey.is-size-6
            | Comentarios: 
            b {{ ticket.comentarios }}
          p.has-text-grey.is-size-6
            | Restante: 
            b {{ ticket.restante === 1 ? `${ticket.restante} día` : `${ticket.restante} días`  }}
        .column.is-6
          figure.image.is-256x256
            img(:src="getEvidencia(ticket.evidencia)")

</template>

<script>
  export default {
    name: 'CardResolucion',
    props: {
      ticket: {
        type: Object,
        default: ()=> {}
      },
    },
    methods: {
      getDiagnostico(diagnostico) {
        switch (diagnostico) {
          case 0:
            return 'Reparado al 100%.'
          case 1: 
            return 'Reparado al 75%.'
          case 2: 
            return 'Reparado al 50%.'
          case 3: 
            return 'Reparado al 25%.'
          case 4: 
            return 'No se puede reparar.'
          default: 
          return ''
        }
      },
      getEvidencia(evidencia) {
        let currentURL = window.location.hostname
        return `https://${currentURL}${evidencia}`
      }
      
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/CardResolucion.vue